<template>
  <div class="comp-ly-association">
    <template v-if="fieldValue.value">
      <template v-if="defaultShow">
        <span @click.stop="toDetails" v-if="!fieldValue?.deleted">
          <fh-ellipsis :content="fieldValue?.label || associationEmptyText" />
        </span>
        <jw-tag color="cyan" class="text-delete-through-line" v-else size="small"> <fh-ellipsis :content="fieldValue?.label" /></jw-tag>
      </template>
      <template v-else>
        <span v-if="!fieldValue?.deleted">
          <jw-typography-paragraph
            class="ellipsis-content"
            :ellipsis="{
              rows: 1,
              showTooltip: true,
              css: true
            }"
          >
            <span class="link-text" data-link="ass-field" @click.stop="toDetails">{{ fieldValue?.label || associationEmptyText }}</span>
          </jw-typography-paragraph>
        </span>
        <span class="text-delete-through-line" v-else>
          <jw-typography-paragraph
            class="ellipsis-content"
            :ellipsis="{
              rows: 1,
              showTooltip: true,
              css: true
            }"
          >
            <span class="link-text">{{ fieldValue?.label || associationEmptyText }}</span>
          </jw-typography-paragraph>
        </span>
      </template>
    </template>
    <template v-else>
      -
      <jw-tooltip v-if="fieldName == 'customerId' && detailEntity == 3 && detailPermission?.value == 1" :content="$t('tips.aPaas')" position="rt" mini>
        <icon-exclamation-circle-fill size="20" style="color: orange; cursor: pointer" @click="relevanceCustomer" />
      </jw-tooltip>
    </template>
  </div>
  <div class="detail-drawer">
    <!--主对象公共详情  S-->
    <ly-detail ref="detailRef" :mask="mask"></ly-detail>
    <!-- 关联客户-搜索客户 -->
    <xl-band-customer v-if="fieldName == 'customerId' && detailEntity == 3 && detailPermission?.value == 1" :mask="mask" ref="customerRef" @cb="loadTList" @addCustom="addCustom"></xl-band-customer>
  </div>
</template>

<script setup>
import { reactive, ref, computed, provide, inject } from 'vue';
import useViewFields from '@/hooks/view-fields';
import { associationEmptyText } from '@/utils/const';

import FhEllipsis from '@/components/fh-ellipsis/index.vue';
const { enableList, getViewFields } = useViewFields();

import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const props = defineProps({
  fieldName: {
    type: String,
    default: ''
  },
  isList: {
    type: Boolean,
    default: false
  },
  isTable: {
    type: Boolean,
    default: false
  },
  value: {
    //字段列表
    type: Object,
    default: () => {},
    required: true
  },
  // 当前点开的entity
  entity: {
    //字段列表
    type: String || Number,
    required: true
  },
  // 当前列表的entity
  listEntity: {
    //字段列表
    type: String || Number
  },
  entityId: {
    type: String || Number
  },
  mask: {
    // 是否有遮罩
    type: Boolean
  },
  defaultShow: {
    type: Boolean,
    default: false
  },
  isLink: {
    type: Boolean,
    default: false
  }
});
const detailRef = ref(); //公共抽离组件
const customerRef = ref(); //关联客户
const clientUpdate = ref();
const fieldValue = computed(() => props.value);
const entityId = computed(() => props.entity);
const detailEntity = computed(() => inject('detailParams')?.entity);
const detailPermission = computed(() => inject('detailParams')?.permission);
const detailId = computed(() => inject('detailParams')?.id);
// console.log(65, fieldValue.value, entityId.value, props.listEntity);
const data = reactive({
  id: null,
  entity: null,
  customerName: '',
  specialProduct: [7, 9, 11, 14, 32] //特殊产品对象
});
const emit = defineEmits(['cb', 'cbStatus']);

const toDetails = () => {
  console.log('查询关联跳转', fieldValue.value);
  data.entity = fieldValue.value?.business || entityId.value;
  if (data.specialProduct.includes(Number(data.entity))) {
    //特殊产品显示不能点击状态
    return false;
  }
  if (!data.entity) return false; //没有entity禁止跳转
  data.id = fieldValue.value?.value;

  if (data.entity == 1) {
    data.tab = 'clueDetail';
  } else if (data.entity == 2) {
    //点击公司名称--客户详情
    data.tab = 'clientDetail';
  } else if (data.entity == 3) {
    // 点击商机名称--商机详情
    data.tab = 'opportunityDetail';
  } else if (data.entity == 4) {
    // 点击产品管理--产品管理详情
    data.tab = 'productDetail';
  } else if (data.entity == 6) {
    // 点击报价单名称--报价单详情
    data.tab = 'priceSheetDetail';
  } else if (data.entity == 8) {
    // 点击合同编号--合同详情
    data.tab = 'contractDetail';
  } else if (data.entity == 10) {
    // 点击销售订单编号--销售订单详情
    data.tab = 'orderDetail';
  } else if (data.entity == 12) {
    // 点击售后服务编号--售后服务详情
    data.tab = 'serviceDetail';
  } else if (data.entity == 13) {
    // 点击销售退货编号--销售退货单详情
    data.tab = 'returnOrderDetail';
  }
  if (data.entity === 2) {
    detailRef.value.openDialog(props.listEntity);
  } else {
    detailRef.value.openDialog();
  }
  emit('cbStatus', true);
};

const loadTList = () => {
  emit('cb');
};
// 关联客户
const relevanceCustomer = () => {
  data.id = detailId;
  data.type = 3;
  const params = {
    type: data.type,
    customerName: '' //record.customerId?.label
  };
  customerRef.value.correlationOpen(params);
};

//创建客户
const addCustom = async () => {
  await getViewFields({ id: 2 }); //获取客户所有字段
  data.customFieldList = enableList;
  const params = {
    record: data.customFieldList,
    type: 1, //0 编辑，1 新增
    title: t('新增'), //弹窗标题
    hasEdit: 0, //是否显示编辑，0 无，1 有
    name: data.customerName,
    fromPage: 3, //1 线索，2 客户 3 商机 4 产品 5 客户公海等
    opportunityId: computed(() => data.id) //商机id
  };
  clientUpdate.value?.clineOpenShow(params); //调用新建页面的方法
};
provide('globalParams', {
  id: computed(() => data.id),
  entity: computed(() => data.entity),
  viewId: -1,
  // 标记这次详情是从查找关联进入，后续编辑时据此优先使用默认视图。
  fromAssociationDetail: true
});
</script>
<style scoped lang="less">
@import './ly-association.less';
</style>
